export enum SUCCESS_MESSAGES {
  ApproveAndReleaseSuccess = "The selected Doppler Run has been approved and released successfully.",
}
